import React from "react";
import { Link } from "react-router-dom";
import { serviceAreas } from "../../data/services";
import { SectionLabel } from "../SectionLabel";
export function AcrossBoth() {
  const process = serviceAreas[2];
  return <section aria-labelledby="across-both" className="bg-stone/40" data-id="element-582" data-mp="237thnqhkprnu">
      <div className="shell py-24 md:py-32" data-id="element-583" data-mp="285336v1udj6e">
        <div className="grid grid-cols-12 gap-x-6 gap-y-14" data-id="element-584" data-mp="2864ortghho2d">
          <div className="col-span-12 lg:col-span-5" data-id="element-585" data-mp="2vuxev9afd1p2">
            <SectionLabel data-id="element-586" data-mp="2vxa509qc6id7">Across both</SectionLabel>
            <h2 id="across-both" className="mt-6 font-display text-[clamp(2.25rem,4.4vw,3.75rem)] leading-[1.05] text-navy" data-id="element-587" data-mp="30t8p3l4mte7t">
              Process &amp; Controls
            </h2>
            <p className="mt-5 font-display text-2xl italic leading-snug text-oxblood" data-id="element-588" data-mp="2r3yx059sfvjp">{process.tagline}</p>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-charcoal/80" data-id="element-589" data-mp="3etjkn1gvzgzb">
              Documentation, controls, workflows, continuity, and clean-up don’t belong to one side. They hold payroll
              and HR technology together — so we build them into both.
            </p>
            <Link to={process.path} className="link-rule mt-10" data-id="element-590" data-mp="2ncdfuta1o7qe">
              Explore Process &amp; Controls
            </Link>
          </div>

          <div className="col-span-12 lg:col-span-6 lg:col-start-7" data-id="element-591" data-mp="322kq4lpwekg0">
            <div aria-hidden className="grid grid-cols-2 gap-3" data-id="element-592" data-mp="2xa1cjor7npb7">
              {["Payroll Operations", "HR Technology"].map(name => <div key={name} className="border border-navy bg-ivory px-6 py-8" data-id="element-593" data-mp="3azv5oj9r0vqq">
                  <p className="font-display text-2xl text-navy" data-id="element-594" data-mp="3623czn1a55lh">{name}</p>
                </div>)}
              <div className="col-span-2 bg-oxblood px-6 py-5" data-id="element-595" data-mp="3kz44pqjh10jy">
                <p className="eyebrow text-ivory" data-id="element-596" data-mp="3g1u89qxnzomm">Process &amp; Controls — beneath both</p>
              </div>
            </div>
            <ul className="mt-10 grid grid-cols-1 gap-x-8 border-b border-stone sm:grid-cols-2" data-id="element-597" data-mp="1qme8v39jlh9x">
              {process.highlights.map(h => <li key={h} className="border-t border-stone py-3 text-[15px] text-charcoal" data-id="element-598" data-mp="2bb6u4uyhcob3">
                  {h}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}